<template>
  <div class="agreement-table">
    <el-table :data="agreements.data" class="w100" @sort-change="sortMethod" stripe>
      <el-table-column label="Title" prop="title" sortable></el-table-column>
      <el-table-column label="Page Type" prop="page_type" sortable>
        <template slot-scope="props">
          {{ agreementType(props.row.page_type) }}
        </template>
      </el-table-column>
      <el-table-column label="Last Updated" prop="updated_at" sortable>
        <template slot-scope="props">
          {{ moment(props.row.updated_at).format('LL') }}
        </template>
      </el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="props">
          <el-tooltip content="Edit Agreement" placement="top">
            <el-button type="warning" circle size="small" icon="el-icon-edit"
                       @click="openModal(props.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="float-right" background @size-change="sizeChange" @current-change="currentChange"
                   :current-page.sync="agreements.current_page" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="agreements.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex"
import moment from "moment"

export default {
  name: "Table",

  data() {
    return { moment }
  },

  computed: {
    ...mapState('agreement', ['agreements', 'pageSize']),
  },

  methods: {
    ...mapActions('agreement', ['getAgreements', 'getPageTypes']),
    ...mapMutations('agreement', [
        'setCurrentPage', 'setPageSize', 'setOrder', 'setAgreement', 'setModalAction', 'setModal'
    ]),

    sortMethod(sort) {
      if (!sort.prop || !sort.order) return
      const order = { 'descending': 'desc', 'ascending': 'asc' }[sort.order]

      this.setCurrentPage(1)
      this.setOrder(`orderBy=${sort.prop},${order}`)

      this.getAgreements()
    },

    openModal(agreement) {
      agreement = { ...agreement }

      this.setAgreement(agreement)
      this.setModalAction('update')
      this.setModal(true)
    },

    sizeChange(page) {
      this.setPageSize(page)
      this.getAgreements()
    },

    currentChange(page) {
      this.setCurrentPage(page)
      this.getAgreements()
    },

    agreementType(agreementNumber) {
      if (agreementNumber === 1) return 'Shorts Agreement'
      else if(agreementNumber === 2) return 'Channel Summary'
      else if (agreementNumber === 2) return 'Artist Label Summary'
      return ''
    }
  },

  async created() {
    await this.getAgreements()
    await this.getPageTypes()
  }
}
</script>

<style scoped lang="scss">

</style>